import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Snackbar, Alert, IconButton, Typography, Button, Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { handleAlertOpenClose } from "./statemanagement/notificationSlice";
import { useSelector } from "react-redux";
import { fetchNotifications } from "./statemanagement/asyncThunkAPI";

const NotificationAlert = ({ setAnchorEl }) => {
  const { count, openAlert } = useSelector(state => state.notificationData);
  const dispatch = useDispatch();
  /**
   * close alert handler
   * @param {*} _ 
   * @param {*} reason 
   * @returns 
   */
  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    dispatch(handleAlertOpenClose(false))
  };


  /**
   * function to close alert and open notification pop up
   */
  const handleOpenNotificationPop = (event) => {
    setAnchorEl(event.currentTarget);
    dispatch(fetchNotifications());
    dispatch(handleAlertOpenClose(false));
  }

  /**
   * dispatch if the count changes and count greater than zero
   */
  useEffect(() => {
    if (count > 0) {
      dispatch(handleAlertOpenClose(true))
    }
  }, [count]);

  return (
    <Snackbar
      open={openAlert}
      autoHideDuration={10000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity="warning"
        sx={{ width: "100%", alignItems: "center" }} // keeps icon centered
        action={
          <Box>
            <Button color="inherit" size="small"
              onClick={(event) => handleOpenNotificationPop(event)}>
              Open
            </Button>
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
        }
      >
        You have <Typography variant="button" pr={0.1} pl={0.1}>{count}</Typography> new notification please check
      </Alert>
    </Snackbar>
  );
};

export default NotificationAlert;
